"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 3.0.11
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactTypeToJSON = exports.ContactTypeFromJSONTyped = exports.ContactTypeFromJSON = exports.ContactType = void 0;
/**
 * The type of contact
 * @export
 * @enum {string}
 */
var ContactType;
(function (ContactType) {
    ContactType["EVERIFY"] = "EVERIFY";
    ContactType["EVERIFYMOUSIGNATORY"] = "EVERIFY_MOU_SIGNATORY";
    ContactType["EVERIFYPENDINGUSER"] = "EVERIFY_PENDING_USER";
    ContactType["SAVETRAINING"] = "SAVE_TRAINING";
    ContactType["SAVEPROGRAM"] = "SAVE_PROGRAM";
    ContactType["SAVEFINANCIAL"] = "SAVE_FINANCIAL";
    ContactType["SAVETECHNOLOGICAL"] = "SAVE_TECHNOLOGICAL";
    ContactType["SAVEMANAGEMENT"] = "SAVE_MANAGEMENT";
    ContactType["SAVELEGAL"] = "SAVE_LEGAL";
    ContactType["SAVEOTHER"] = "SAVE_OTHER";
})(ContactType = exports.ContactType || (exports.ContactType = {}));
function ContactTypeFromJSON(json) {
    return ContactTypeFromJSONTyped(json, false);
}
exports.ContactTypeFromJSON = ContactTypeFromJSON;
function ContactTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ContactTypeFromJSONTyped = ContactTypeFromJSONTyped;
function ContactTypeToJSON(value) {
    return value;
}
exports.ContactTypeToJSON = ContactTypeToJSON;
